<div id="wrapper">
	<caass-menu></caass-menu>

	<div id="page-wrapper" class="gray-bg">
		<caass-navnotification></caass-navnotification>

		<div class="wrapper wrapper-content animated fadeInRight">
			<router-outlet></router-outlet>
		</div>

		<div *ngIf="ShowSupportChatWindow == true" class="BottomRightPopup">
			<caass-support-chat-window></caass-support-chat-window>
		</div>
	</div>
</div>
